<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <!--<div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
            optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false"
            placeholder="Select Property" readonly="true">
          </p-dropdown>
          <label for="Select Property">Select Property</label>
          <span *ngFor="let validation of validationMessages.shortTermRentalId">
            <small class="p-invalid"
              *ngIf="form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)">{{validation.message}}
            </small>
          </span>
        </span>
      </div>-->

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="testSubjectName" id="testSubjectName" type="text" pInputText readonly="true">
          <label for="testSubjectName">Test Subject Name</label>
          @for (validation of validationMessages.testSubjectName; track validation) {
            <span>
              @if (form1.get('testSubjectName').hasError(validation.type) && (form1.get('testSubjectName').dirty || form1.get('testSubjectName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="developments" formControlName="developmentId" optionLabel="adrDevelopmentName"
            optionValue="developmentId" [filter]="true" filterBy="adrDevelopmentName" [showClear]="false"
            placeholder="Select Development" readonly="true">
          </p-dropdown>
          <label for="Select Development">Select Development</label>
          @for (validation of validationMessages.developmentId; track validation) {
            <span>
              @if (form1.get('developmentId').hasError(validation.type) && (form1.get('developmentId').dirty || form1.get('developmentId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="activityId" id="activityId" type="number" pInputText readonly="true">
          <label for="activityId">Activity Id</label>
          @for (validation of validationMessages.activityId; track validation) {
            <span>
              @if (form1.get('activityId').hasError(validation.type) && (form1.get('activityId').dirty || form1.get('activityId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="featureId" id="featureId" type="number" pInputText readonly="true">
          <label for="featureId">Feature Id</label>
          @for (validation of validationMessages.featureId; track validation) {
            <span>
              @if (form1.get('featureId').hasError(validation.type) && (form1.get('featureId').dirty || form1.get('featureId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="guestBookId" id="guestBookId" type="number" pInputText readonly="true">
          <label for="guestBookId">Guest Book Id</label>
          @for (validation of validationMessages.guestBookId; track validation) {
            <span>
              @if (form1.get('guestBookId').hasError(validation.type) && (form1.get('guestBookId').dirty || form1.get('guestBookId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="createdByUserId" id="createdByUserId" type="number" pInputText readonly="true">
          <label for="createdByUserId">Created By User Id</label>
          @for (validation of validationMessages.createdByUserId; track validation) {
            <span>
              @if (form1.get('createdByUserId').hasError(validation.type) && (form1.get('createdByUserId').dirty || form1.get('createdByUserId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="testName" id="testName" type="text" pInputText readonly="true">
          <label for="testName">Test Name</label>
          @for (validation of validationMessages.testName; track validation) {
            <span>
              @if (form1.get('testName').hasError(validation.type) && (form1.get('testName').dirty || form1.get('testName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="testResultValue" id="testResultValue" type="text" pInputText readonly="true">
          <label for="testResultValue">Test Result Value</label>
          @for (validation of validationMessages.testResultValue; track validation) {
            <span>
              @if (form1.get('testResultValue').hasError(validation.type) && (form1.get('testResultValue').dirty || form1.get('testResultValue').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="testResultStatus" id="testResultStatus" type="text" pInputText readonly="true">
          <label for="testResultStatus">Test Result Status</label>
          @for (validation of validationMessages.testResultStatus; track validation) {
            <span>
              @if (form1.get('testResultStatus').hasError(validation.type) && (form1.get('testResultStatus').dirty || form1.get('testResultStatus').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="testCategory" id="testCategory" type="text" pInputText readonly="true">
          <label for="testCategory">Test Category</label>
          @for (validation of validationMessages.testCategory; track validation) {
            <span>
              @if (form1.get('testCategory').hasError(validation.type) && (form1.get('testCategory').dirty || form1.get('testCategory').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <textarea formControlName="testResultDesc" id="testResultDesc" [rows]="2" pInputTextarea readonly="true"></textarea>
          <label for="testResultDesc">Test Result Desc</label>
          @for (validation of validationMessages.testResultDesc; track validation) {
            <span>
              @if (form1.get('testResultDesc').hasError(validation.type) && (form1.get('testResultDesc').dirty || form1.get('testResultDesc').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <textarea formControlName="testExpectationDesc" id="testExpectationDesc" [rows]="2" pInputTextarea readonly="true"></textarea>
          <label for="testExpectationDesc">Test Expectation Desc</label>
          @for (validation of validationMessages.testExpectationDesc; track validation) {
            <span>
              @if (form1.get('testExpectationDesc').hasError(validation.type) && (form1.get('testExpectationDesc').dirty || form1.get('testExpectationDesc').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3">
          <textarea formControlName="testResultUrl" id="testResultUrl" [rows]="1" pInputTextarea readonly="true"></textarea>
          <label for="testResultUrl">Test Result Url</label>
          @for (validation of validationMessages.testResultUrl; track validation) {
            <span>
              @if (form1.get('testResultUrl').hasError(validation.type) && (form1.get('testResultUrl').dirty || form1.get('testResultUrl').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

    </div>
  </div>
  <hr>
    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
        </div>
      </div>
    </div>
  </div>